module.exports = __webpack_public_path__ + "static/media/a2.fb54676e.png";